let tempCounter = 0;
const buildTempId = () => `temp-empleado-${tempCounter++}`;

const toStr = (v) => (v != null ? String(v).trim() : "");

export const normalizeEmpleado = (e = {}, fallbackId) => ({
  id: e.id ?? fallbackId ?? buildTempId(),
  nombres:          toStr(e.nombres),
  apellidos:        toStr(e.apellidos),
  nombreCompleto:   `${toStr(e.apellidos)} ${toStr(e.nombres)}`.trim(),
  cedula:           toStr(e.cedula),
  telefono:         toStr(e.telefono),
  email:            toStr(e.email),
  puestoId:         e.puesto_id    ?? e.puestoId    ?? null,
  puestoNombre:     toStr(e.cargo_nombre || e.puestoNombre),
  tipoPersonal:     e.tipo_personal     || e.tipoPersonal     || "administrativo",
  tipoContratacion: e.tipo_contratacion || e.tipoContratacion || "nomina",
  fechaIngreso:     e.fecha_ingreso     ?? e.fechaIngreso     ?? null,
  sueldoBase:       parseFloat(e.sueldo_base ?? e.sueldoBase) || 0,
  ruc:              toStr(e.ruc),
  usuarioId:        e.usuario_id  ?? e.usuarioId  ?? null,
  docenteId:        e.docente_id  ?? e.docenteId  ?? null,
  contificoPersonaId: e.contifico_persona_id || e.contificoPersonaId || null,
  estado:           e.estado || "activo",
  observaciones:    toStr(e.observaciones),
  createdAt:        e.created_at || e.createdAt || null,
});

export const buildEmpleadoPayload = (form) => ({
  nombres:            form.nombres.trim(),
  apellidos:          form.apellidos.trim(),
  cedula:             form.cedula.trim(),
  telefono:           form.telefono?.trim() || null,
  email:              form.email?.trim() || null,
  puesto_id:          form.puestoId ? Number(form.puestoId) : null,
  tipo_personal:      form.tipoPersonal,
  tipo_contratacion:  form.tipoContratacion,
  fecha_ingreso:      form.fechaIngreso || null,
  sueldo_base:        parseFloat(form.sueldoBase) || 0,
  ruc:                form.ruc?.trim() || null,
  estado:             form.estado,
  observaciones:      form.observaciones?.trim() || null,
  docente_id:         form.docenteId ?? null,
  usuario_id:         form.usuarioId ?? null,
});

export const tipoPersonalLabel = (tipo) => {
  switch (tipo) {
    case "docente":        return "Docente";
    case "administrativo": return "Administrativo";
    case "servicios":      return "Servicios";
    default:               return tipo || "—";
  }
};

export const tipoContratacionLabel = (tipo) => {
  switch (tipo) {
    case "nomina":   return "Nómina";
    case "servicios": return "Servicios";
    case "hibrido":  return "Híbrido";
    default:         return tipo || "—";
  }
};
